var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:#395185;}\r\n\t.st1{fill:#FFFFFF;}\r\n"),React.createElement("g",{"key":1},[React.createElement("path",{"className":"st0","d":"M483.7,512c15.6,0,28.3-12.7,28.3-28.3V28.3C512,12.7,499.3,0,483.7,0H28.3C12.6,0,0,12.7,0,28.3v455.5\r\n\t\tC0,499.3,12.6,512,28.3,512H483.7","key":0}),React.createElement("path",{"className":"st1","d":"M353.3,512V313.7h66.6l10-77.3h-76.5v-49.3c0-22.4,6.2-37.6,38.3-37.6l40.9,0V80.4c-7.1-0.9-31.4-3-59.6-3\r\n\t\tc-59,0-99.4,36-99.4,102.1v57h-66.7v77.3h66.7V512H353.3","key":1})])]);
}

Facebook.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
